import NumberFlow from '@number-flow/react'

import { type AnimatedNumberProps } from '~/components/component-library/AnimatedNumber/types'

export { type AnimatedNumberProps } from '~/components/component-library/AnimatedNumber/types'

const TRANSITION_DURATION = 300

/**
 * AnimatedNumber component that provides smooth number transitions using NumberFlow
 *
 * @param props - Component props
 * @param props.value - The numeric value to display and animate
 * @param props.format - Optional Intl.NumberFormatOptions for custom formatting (defaults to USD currency)
 * @param props.className - Optional CSS class names for styling
 * @param props.prefix - Optional prefix to display before the number
 * @param props.suffix - Optional suffix to display after the number
 * @returns JSX element with animated number display
 */
export const AnimatedNumber = ({
  value,
  format,
  className,
  prefix,
  suffix,
}: AnimatedNumberProps) => {
  return (
    <NumberFlow
      value={value}
      transformTiming={{ duration: TRANSITION_DURATION }}
      className={className}
      prefix={prefix}
      suffix={suffix}
      format={
        format || {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      }
    />
  )
}
